<template>
  <div class="rolesList">
		<!--<v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>-->   
    <br /><br />
      <center v-if="loaded == false"><img class="imgLoader" src="../shared/assets/images/3dloader.gif" /></center>             
		<v-data-table v-if="loaded == true" loading="true" :headers="headers" :items="userRoles" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr class="sortableRow" id="rows">				
					<td class="px-1" width="5%"><v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn></td>
					<td width="15%" v-if="objAuthorize.privileges.indexOf('RFC_REPORT') !== -1">{{ props.item.name }} <small>( Level {{ props.item.level }} )</small></td>
					<td width="20%" v-else>{{ props.item.name }} <small>( Level {{ props.item.level }} )</small></td>
					<td width="35%" >{{ props.item.description }}</td>
					<td  width="10%">{{ userTypes[props.item.user_type] }}</td>					
					<td  width="5%">{{ props.item.active }}</td>
					<td width="5%" v-if="objAuthorize.privileges.indexOf('EDIT_ROLE_PRICELISTS') !== -1" ><a @click.prevent="fncRolePlists(props.item.id, props.item.name)">Pricelists</a></td>
					<td width="5%" v-if="objAuthorize.privileges.indexOf('RFC_REPORT') !== -1" ><a @click.prevent="fncRoleStatus(props.item.id, props.item.name)">RFC Status</a></td>
					<td width="5%" v-if="objAuthorize.privileges.indexOf('EDIT_ROLE_PRIVS') !== -1" ><a @click.prevent="fncGetRolePrivs(props.item.id, props.item.name)">Privileges</a></td>
					<td width="5%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1" ><a @click.prevent="fncShowEdit(props.item.id, props.item.name)"><i class="material-icons">edit</i></a></td>
					<td width="5%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1" ><a @click.prevent="fncRoleDelete(props.item.id, props.item.linked_users, props.item.name)"><i class="material-icons">delete</i></a></td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex'; 
  import Sortable from 'sortablejs';

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {
			search: '',	
			headers: [],
			userTypes: {
				'1': 'Manufacturer User',
				'2': 'Customer User',
				'3': 'Specifier User',
				'4': 'Public User',
                '5': 'Non-registered User',
                '6': 'Vendor User'
            },
            loaded: true
		}
	},
	methods: {
		fncShowEdit (roleId, roleName) {			
			this.$store.commit('setObjRoleEdit', roleId);					
			var modalDetails = { title: 'Edit Role - ' + roleName, component: 'modal-role-edit', mstate: true };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncRolePlists (roleId, roleName) {
			this.$store.commit('setObjRoleEdit', roleId);
			var modalDetails = { title: 'Manage Role Pricelists - ' + roleName, component: 'modal-role-plists', mstate: true };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncRoleStatus (roleId, roleName) {
			this.$store.commit('setObjRoleEdit', roleId);
			this.$store.dispatch('fncGetRoleStatus', roleId);
			/*var modalDetails = { title: 'Manage Role Pricelists - ' + roleName, component: 'modal-role-status', mstate: true };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});*/
		},
		fncRoleDelete (roleId, linked_users, roleName) {		
			if( linked_users == '0' ) {
				var confirmDelete = confirm('Are you sure you would like to remove '+roleName+'?');
				if( confirmDelete === true ) {
					this.$store.dispatch({
						type: 'fncRoleDelete',
						roleId: roleId
					});
				}				
			} else {				
				var snackDetails = { color: 'error', message: 'This role cannot be deleted as it has linked users', display: true };
				this.$store.commit('setSnack', snackDetails);
			}					
		},
		fncGetRolePrivs(roleId, roleName) {		
			this.$store.dispatch({
				type: 'fncGetRolePrivs',
                roleId: roleId,
                roleName: roleName,
				privList: this.privList
			});
		},
        fncReorderRoles({ oldIndex, newIndex }) {       
		    this.$store.dispatch({
				type: 'fncReorderRoles',
				start: oldIndex,
				end: newIndex
          });            
        }
	},
	computed: {
		...mapGetters([			
			'userRoles',
			'objRoleEdit',
			'objAuthorize',
			'privList'	
		])
	},
	beforeMount() {
		this.$store.dispatch('fncPopulateRoles');
		this.$store.dispatch('fncPopulatePrivList');
	},
	created() {
		if(this.objAuthorize.privileges.indexOf('RFC_REPORT') !== -1) {
			this.headers = [
				{ text: '', value: '', sortable: false, width: '5%' },
				{ text: 'NAME', value: 'name', sortable: false, width: '15%' },
				{ text: 'DESCRIPTION', value: 'description', sortable: false, width: '35%' },
				{ text: 'USER TYPE', value: 'user_type', sortable: false, width: '10%' },
				{ text: 'ACTIVE', value: 'active', sortable: false, width: '5%' },
			]
		} else {
			this.headers = [
				{ text: '', value: '', sortable: false, width: '5%' },
				{ text: 'NAME', value: 'name', sortable: false, width: '20%' },
				{ text: 'DESCRIPTION', value: 'description', sortable: false, width: '35%' },
				{ text: 'USER TYPE', value: 'user_type', sortable: false, width: '10%' },
				{ text: 'ACTIVE', value: 'active', sortable: false, width: '5%' },
			]
		}
		if( this.objAuthorize.privileges.indexOf('EDIT_ROLE_PRICELISTS') !== -1 ) {
			this.headers.push({ text: 'PRICE LISTS', value: 'plists', sortable: false, width: '5%' });
		}
		if( this.objAuthorize.privileges.indexOf('RFC_REPORT') !== -1 ) {
          this.headers.push({ text: 'STATUS', value: 'status', sortable: false, width: '5%' });
		}
		if( this.objAuthorize.privileges.indexOf('EDIT_ROLE_PRIVS') !== -1 ) {			
          this.headers.push({ text: 'PRIVILEGES', value: 'privileges', sortable: false, width: '5%' });
		}
		if( this.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1 ) {			
          this.headers.push({ text: 'EDIT', value: 'edit', sortable: false, width: '5%' });
		}
		if( this.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1 ) {			
          this.headers.push({ text: 'DELETE', value: 'delete', sortable: false, width: '5%' });
		}
	},
	mounted () {
        new Sortable(
            this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
            {
                draggable: '.sortableRow',
                handle: '.sortHandle',
                onUpdate: this.fncReorderRoles                  
            }
        )         
    },
    watch: {
      userRoles() {
        this.loaded = true;
      }      
    }
}	
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>